const IAtom = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9999 11.5001H11.0108M14.8451 15.3452C9.74842 20.4418 3.89527 22.852 1.77167 20.7284C-0.351923 18.6048 2.0582 12.7516 7.15483 7.65499C12.2515 2.55835 18.1046 0.14823 20.2282 2.27183C22.3518 4.39542 19.9417 10.2486 14.8451 15.3452ZM14.845 7.65479C19.9416 12.7514 22.3518 18.6046 20.2282 20.7282C18.1046 22.8518 12.2514 20.4416 7.15479 15.345C2.05816 10.2484 -0.351967 4.39523 1.77163 2.27163C3.89523 0.148033 9.74838 2.55816 14.845 7.65479ZM11.5437 11.5001C11.5437 11.8004 11.3003 12.0439 10.9999 12.0439C10.6996 12.0439 10.4562 11.8004 10.4562 11.5001C10.4562 11.1998 10.6996 10.9563 10.9999 10.9563C11.3003 10.9563 11.5437 11.1998 11.5437 11.5001Z"
        stroke="#6CB6E3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IAtom
